import _regenerator from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import Swiper, { Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import { gsap } from "gsap";
import { Observer } from "gsap/Observer";
import { useHead } from "@unhead/vue";
import LangSelect from "@/components/basic/langselect/index.vue";
import BgmAudio from "@/components/basic/audio/audio.vue";
import PcButton from "@/components/basic/pc-button.vue";
import { track } from '@/lib/utils';
import IconBgmActive from "@/resources/images/btn-bgm-active.png";
import IconBgm from "@/resources/images/btn-bgm.png";
import Bgm from "@/resources/audio/bgm.mp3";
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup: function setup(__props) {
    Swiper.use([Pagination]);
    var _useCommon = useCommon(),
      getI18nWord = _useCommon.getI18nWord,
      parseI18nJson = _useCommon.parseI18nJson,
      lang = _useCommon.lang;
    var _storeToRefs = storeToRefs(useFlexStore()),
      rem = _storeToRefs.rem;
    var _useFlexStore = useFlexStore(),
      initFlexiable = _useFlexStore.initFlexiable;
    var BANNER_CNT = 5;
    var bannerSwiper = ref();
    var rewardsRef = ref();
    var swiperIndex = computed(function () {
      return bannerSwiper.value ? bannerSwiper.value.realIndex : -1;
    });
    var eventRewards = computed(function () {
      if (swiperIndex.value < 0) return [];
      var data = parseI18nJson("event-rewards-".concat(swiperIndex.value + 1));
      return data !== null && data !== void 0 ? data : [];
    });
    var mediaData = computed(function () {
      if (swiperIndex.value < 0) return [];
      var data = parseI18nJson("media-list");
      return data !== null && data !== void 0 ? data : [];
    });
    useHead({
      title: getI18nWord("web-title")
    });
    initFlexiable();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            track({
              category: 'page',
              action: 'view'
            });
            _context.n = 1;
            return nextTick();
          case 1:
            bannerSwiper.value = new Swiper(".swiper", {
              width: 6.73 * rem.value,
              watchOverflow: true,
              loop: true,
              pagination: {
                el: ".swiper-pagination",
                // 必须匹配模板中的分页器类名
                type: "bullets"
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
              },
              on: {
                resize: function resize() {
                  if (!bannerSwiper.value) return;
                  bannerSwiper.value.params.width = 6.73 * rem.value;
                  bannerSwiper.value.update();
                }
              }
            });
            Observer.create({
              target: ".reward-list",
              type: "touch,pointer",
              lockAxis: true,
              dragMinimum: 50,
              onLeft: function onLeft() {
                return rewardsScrollX("right");
              },
              onRight: function onRight() {
                return rewardsScrollX("left");
              }
            });
            gsap.to(".black-mask", {
              opacity: 1,
              duration: 1,
              scrollTrigger: {
                trigger: ".ghost",
                start: "bottom bottom",
                end: "bottom top",
                scroller: "#app > .content",
                scrub: true
              }
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    function rewardsScrollX(direct) {
      var dist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
      if (!rewardsRef.value) return;
      var offset = dist / 100 * rem.value;
      gsap.to(rewardsRef.value, {
        scrollTo: {
          x: rewardsRef.value.scrollLeft + (direct === "right" ? 1 : -1) * offset,
          autoKill: true
        },
        ease: "power3.out",
        duration: 0.2
      });
    }
    function swiperToPrev() {
      if (!bannerSwiper.value) return;
      track({
        category: 'button',
        action: 'click',
        label: 'LeftArrow'
      });
      bannerSwiper.value.slidePrev();
    }
    function swiperToNext() {
      if (!bannerSwiper.value) return;
      track({
        category: 'button',
        action: 'click',
        label: 'RightArrow'
      });
      bannerSwiper.value.slideNext();
    }
    function clickJoinNow() {
      track({
        category: 'button',
        action: 'click',
        label: 'JoinNow'
      });
      openUrl(getI18nWord('join-now-url'));
    }
    function clickJoinEvent() {
      track({
        category: 'button',
        action: 'click',
        label: 'JoinEvent',
        value: swiperIndex.value + 1
      });
      openUrl(getI18nWord("event-url-".concat(swiperIndex.value + 1)));
    }
    function clickDownload() {
      track({
        category: 'button',
        action: 'click',
        label: 'Download'
      });
      openUrl(getI18nWord('model-download-url'));
    }
    function clickOpenMedia(media) {
      track({
        category: 'button',
        action: 'click',
        label: {
          facebook: 'Fb',
          discord: 'Discord',
          x: 'X',
          ytb: 'Youtube',
          ins: lang !== 'ko-kr' ? 'Ins' : getI18nWord('ins-name')
        }[media]
      });
      openUrl(getI18nWord("".concat(media, "-url")));
    }
    function clickOpenOfficialSite() {
      track({
        category: 'button',
        action: 'click',
        label: 'OfficialSite'
      });
      openUrl(getI18nWord('official-site-url'));
    }
    function openUrl(url) {
      var _window$open;
      if (!window) return;
      (_window$open = window.open(url, "_blank")) === null || _window$open === void 0 || _window$open.focus();
    }
    return {
      __sfc: true,
      getI18nWord: getI18nWord,
      parseI18nJson: parseI18nJson,
      lang: lang,
      rem: rem,
      initFlexiable: initFlexiable,
      BANNER_CNT: BANNER_CNT,
      bannerSwiper: bannerSwiper,
      rewardsRef: rewardsRef,
      swiperIndex: swiperIndex,
      eventRewards: eventRewards,
      mediaData: mediaData,
      rewardsScrollX: rewardsScrollX,
      swiperToPrev: swiperToPrev,
      swiperToNext: swiperToNext,
      clickJoinNow: clickJoinNow,
      clickJoinEvent: clickJoinEvent,
      clickDownload: clickDownload,
      clickOpenMedia: clickOpenMedia,
      clickOpenOfficialSite: clickOpenOfficialSite,
      openUrl: openUrl,
      LangSelect: LangSelect,
      BgmAudio: BgmAudio,
      PcButton: PcButton,
      IconBgmActive: IconBgmActive,
      IconBgm: IconBgm,
      Bgm: Bgm
    };
  }
});